import React from "react";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import ResetPasswordSuperAdminModal from "../../components/ResetPasswordSuperAdminModal";
import "./index.css";
import InviteTaskerModal from "../../components/InvitaeTakserModal";
import {
  inviteTasker,
  removeTaskerFromAuth,
  resetPassword,
} from "../../api/UserApi";
const user_icon = require("../../assets/media/user.png");
const remove_icon = require("../../assets/media/stop.png");

class BrandTaskers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      domain: [],
      loading: false,
      taskers: [],
      brand_name: "",
      brand_url: "",
    };
  }
  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand, loading: true });
      Firebase.getBrandDataByID(brand, (res) => {
        this.setState({
          logo: res.logo,
          icon: res.icon,
          brand_name: res.name,
          brand_url: res.url,
          hex: res.hex,
          loading: false,
          is_property_brand: res.is_property_brand
            ? res.is_property_brand
            : false,
        });
      });

      Firebase.getTaskersByBrandID(brand, (res) => {
        this.setState({ taskers: res });
      });
    }
  }

  addTasker = ({ firstName, phoneNumber, skill }) => {
    const { brand, brand_name } = this.state;
    Firebase.inviteTasker(firstName, phoneNumber, skill, brand)
      .then(async (uid) => {
        inviteTasker(firstName, brand_name, phoneNumber, uid);
      })
      .catch((err) => {
        alert(err);
      });
  };

  onResetPassword = (password) => {
    const { selectedUser } = this.state;
    if (selectedUser) {
      resetPassword(selectedUser.uid, password).catch(() => {
        console.log("Something went wrong!");
      });
    }
  };

  removeTakser = (tasker) => () => {
    if (tasker.uid) {
      removeTaskerFromAuth(tasker.uid).catch(console.log);
    }
    Firebase.removeTasker(tasker.id);
  };

  editBrandTasker = (item) => () => {
    this.setState({
      selectedUser: item,
    });
  };

  render() {
    const {
      username,
      role,
      logo,
      taskers,
      brand,
      brand_name,
      is_property_brand,
      selectedUser,
    } = this.state;

    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          onHome={this.goBack}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container" style={{ overflowX: "auto" }}>
          <div className="home-content">
            <div className="user-content">
              <div className="member-row header">
                <p style={{ minWidth: 200 }}>Profile Name</p>
                <p style={{ minWidth: 150 }}>Tickets Managed</p>
                <p style={{ minWidth: 150 }}>Tickets Open</p>
                <p style={{ minWidth: 150 }}>Tickets Closed</p>
                <p style={{ minWidth: 150 }}>Status</p>
                <p style={{ minWidth: 200 }}>Phone Number</p>
                <p style={{ minWidth: 300 }}>Email</p>
                <div className="brand-tasker-actions-container" />
              </div>
              {taskers.map((item) => {
                return (
                  <div className="member-row bottom-line">
                    <div
                      style={{
                        minWidth: 200,
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img src={user_icon} className="avatar" alt="icon" />
                      <div className="member-name firstname-container">
                        {item.firstName}
                        <img
                          src={remove_icon}
                          className="remove-icon"
                          alt="remove"
                          onClick={this.removeTakser(item)}
                        />
                      </div>
                    </div>

                    <p style={{ minWidth: 150 }}>0</p>
                    <p style={{ minWidth: 150 }}>0</p>
                    <p style={{ minWidth: 150 }}>0</p>
                    <p
                      style={{
                        color: item.isActive ? "#82b54b" : "#ffb119",
                        minWidth: 150,
                      }}
                    >
                      {item.isActive ? "Active" : "Pending"}
                    </p>
                    <p style={{ minWidth: 200 }}>{item.phoneNumber}</p>
                    <p style={{ minWidth: 300 }}>{item.email || ""}</p>
                    <div className="brand-tasker-actions-container">
                      {item.uid && (
                        <button
                          type="button"
                          className="btn btn-green"
                          data-toggle="modal"
                          data-target="#reset_password_super_admin"
                          onClick={this.editBrandTasker(item)}
                        >
                          Reset password
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
              <button
                type="button"
                className="btn btn-green"
                data-toggle="modal"
                data-target="#invite_tasker"
                style={{ marginTop: 20 }}
              >
                Invite a tasker
              </button>
            </div>
          </div>
        </main>
        <InviteTaskerModal addTasker={this.addTasker} />
        <ResetPasswordSuperAdminModal
          onSave={this.onResetPassword}
          initialValues={selectedUser}
        />
      </div>
    );
  }
}
export default BrandTaskers;



// WEBPACK FOOTER //
// ./src/screens/BrandTaskers/index.js